module.exports = {
	"name": "client",
	"version": "1.67.5",
	"private": true,
	"proxy": "http://localhost:8090",
	"devDependencies": {
		"babel-eslint": "^7.2.3",
		"react-scripts": "0.9.5"
	},
	"dependencies": {
		"chart.js": "^2.7.2",
		"chartjs-plugin-datalabels": "^0.4.0",
		"eventing-bus": "^1.3.3",
		"font-awesome": "^4.7.0",
		"google-libphonenumber": "^3.2.32",
		"js-file-download": "^0.4.1",
		"keymirror": "^0.1.1",
		"moment": "^2.22.2",
		"numeral": "^2.0.6",
		"pdfmake": "^0.1.31",
		"react": "^15.4.2",
		"react-async-script": "^0.9.1",
		"react-block-ui": "^0.2.6",
		"react-bootstrap": "^0.30.8",
		"react-bootstrap-date-picker": "^5.0.1",
		"react-bootstrap-table": "^3.4.2",
		"react-chartjs-2": "^2.7.4",
		"react-dom": "^15.4.2",
		"react-google-recaptcha": "^0.9.9",
		"react-idle-timer": "^4.5.1",
		"react-localization": "^0.1.1",
		"react-router-bootstrap": "^0.24.2",
		"react-router-dom": "^4.1.1",
		"react-scrollable-anchor": "^0.4.2",
		"react-select": "^2.0.0",
		"source-map-explorer": "^1.4.0"
	},
	"scripts": {
		"analyze": "source-map-explorer build/static/js/main.*",
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 767
// module chunks = 0